var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blockProducer)?_c('v-col',{staticClass:"pr-3 pl-0",attrs:{"cols":"auto"}},[_c('chain-b-p-bar-vote-rank',{attrs:{"block-producer":_vm.blockProducer}}),_c('chain-b-p-bar-head-block-producer',{attrs:{"block-producer":_vm.blockProducer}}),_c('chain-b-p-bar-head-block',{attrs:{"block-producer":_vm.blockProducer}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }